// extracted by mini-css-extract-plugin
module.exports = {"container_logo":"logo_container_logo__SSqCo"};